module.exports = __webpack_public_path__ + "static/img/bg_img03.54e65508.png";